function cov_1cmqirc7ik() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinHomeFilled.tsx";
  var hash = "244ddce7049466b3270aaec84a80993db3289a96";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LocationPinHomeFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 64
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "244ddce7049466b3270aaec84a80993db3289a96"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cmqirc7ik = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cmqirc7ik();
var Icon = (cov_1cmqirc7ik().s[0]++, {
  name: 'location-pin-home-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.98959 4.2106C9.30905 0.891144 14.691 0.891144 18.0104 4.2106C21.3299 7.53006 21.3299 12.912 18.0104 16.2314L12 22.2418L5.98959 16.2314C2.67014 12.912 2.67014 7.53006 5.98959 4.2106ZM15.15 13.5003C15.3433 13.5003 15.5 13.3436 15.5 13.1503V9.13253C15.5 9.01832 15.4443 8.9113 15.3507 8.8458L12.2007 6.6408C12.0802 6.55645 11.9198 6.55645 11.7993 6.6408L8.64929 8.8458C8.55572 8.9113 8.5 9.01832 8.5 9.13253V13.1503C8.5 13.3436 8.6567 13.5003 8.85 13.5003H15.15Z\" fill=\"currentColor\"/>"
});
export default Icon;